<script>
import pagination from "@/mixins/pagination";
import tableSearch from "@/mixins/tableSearch";
import _debounce from "lodash/debounce";
import RefreshSearchBtn from "@/views/pages/project/sale/RefreshSearchBtn.vue";
import CommonTableComponent from "@/components/table.vue";
import router from "@/mixins/router";
import apiEndpoints from "@/services/apiEndpoints";

export default {
  name: "WasteTab",
  mixins: [pagination, tableSearch, router],
  components: {
    RefreshSearchBtn,
    CommonTableComponent
  },
  props: {
    activeTabIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      wastes: [],
      filters: {
        keywords: this.$route.query.keywords ? this.$route.query.keywords : "",
        column: this.$route.query.column || "waste_cd",
        dir: this.$route.query.dir || "ASC"
      }
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      this.$emit("get-data", true);
      const url = apiEndpoints.projects_sales_wastes.replace(
        ":id",
        this.$route.params.id
      );
      const sendApiProject = await this.$http.get(url, this.filters);
      const { status, data } = sendApiProject;

      if (status) {
        this.wastes = data.result;
      }
      this.$emit("get-data", false);
    },
    onRefreshSearch() {
      this.$router.replace({
        name: this.$route.name,
        query: { ...this.customQuery, searchToken: this.getSearchToken() }
      });
    },
    handlerSearchValue() {
      this.updateUrlFilters();
    },
    getContainNonActivated(item){
      return item.non_activate_is_exists == 1 ? '未受注': '受注'; 
    }
  },
  watch: {
    "filters.page": {
      immediate: false,
      handler() {
        this.updateUrlFilters();
      }
    }
  },
  computed: {
    customQuery() {
      return {
        activeTabIndex: this.activeTabIndex
      };
    },
    headers() {
      return [
        {
          text: "HK管理番号",
          value: "waste_cd",
          sortable: true,
          width: 20
        },
        {
          text: "廃棄物名",
          value: "name",
          sortable: true
        },
        {
          text: "廃棄物分類",
          value: "waste_category_id",
          sortable: true
        },
        {
          text: "受注状況",
          value: "is_active",
          sortable: false
        },
      ];
    },
    projectId() {
      return this.$route.params.id;
    },
    queryPage() {
      return this.$route.query;
    }
  }
};
</script>
<template>
  <b-container>
    <b-row align-h="center">
      <h5>廃棄物一覧</h5>
      <div class="mt-1">
        <input
          placeholder="フィルター..."
          v-model="filters.keywords"
          v-on:keyup.enter="handlerSearchValue()"
          type="text"
          class="form-control me-2"
        />
      </div>
      <b-col class="mt-1">
        <CommonTableComponent
          :height-class="`table-wrapper-500`"
          :scrollAble="wastes.length >= this.$constant.scroll_able_records"
        >
          <thead class="table-light">
            <tr>
              <th
                v-for="(item, index) in headers"
                :key="index"
                :class="getHeaderClass(item)"
              >
                <span v-if="item.sortable" @click="clickSort(item.value)">
                  {{ item.text }}
                  <i :class="getSortClass(item.value)"></i>
                </span>
                <span v-else>
                  {{ item.text }}
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in wastes"
              :key="index"
              @click.exact="
                redirectRoute(
                  'projects.sales.wastes.detail',
                  {
                    id: projectId,
                    waste_id: item.id
                  },
                  {},
                  queryPage,
                  'projects/sales/waste'
                )
              "
              @click.ctrl="
                redirectRouteTargetBlank(
                  'projects.sales.wastes.detail',
                  {
                    id: projectId,
                    waste_id: item.id
                  },
                  {},
                  queryPage,
                  'projects/sales/waste'
                )
              "
              class="cursor-pointer"
            >
              <td>
                {{ item.waste_cd }}
              </td>
              <td>
                {{ item.name }}
              </td>
              <td>
                {{
                  item.waste_category && item.waste_category.name_abbreviated
                }}
              </td>
              <td>
                {{ getContainNonActivated(item) }}
              </td>
            </tr>
            <tr v-if="!wastes.length">
              <td colspan="6" class="text-center">
                データなし。
              </td>
            </tr>
          </tbody>
        </CommonTableComponent>
      </b-col>
    </b-row>
  </b-container>
</template>
